import Devices from "../models/devices.ts";

const DeviceLayoutWasherDummyData = [
    new Devices({
        id: "84960297-c1fa-16b3-a339-60ab148ff8e9",
        type: "washer",
        name: "Washer 1",
        status: "error",
        courseName: undefined,
        remainTime: undefined,
        model: "FH069FD_T",
        dryType: "nonHeater",
        cycle: 1000,
    }),
    new Devices({
        id: "84960297-c1fa-16b3-a339-60ab148ff8e8",
        type: "washer",
        name: "Washer 2",
        status: "error",
        courseName: undefined,
        remainTime: undefined,
        model: "FH069FD_T",
        dryType: "nonHeater",
        cycle: 1000,
    }),
    new Devices({
        id: "84960297-c1fa-16b3-a339-60ab148ff8e7",
        type: "washer",
        name: "Washer 2",
        status: "error",
        courseName: undefined,
        remainTime: undefined,
        model: "FH069FD_T",
        dryType: "nonHeater",
        cycle: 1000,
    }),
    new Devices({
        id: "84960297-c1fa-16b3-a339-60ab148ff8e6",
        type: "washer",
        name: "Washer 2",
        status: "error",
        courseName: undefined,
        remainTime: undefined,
        model: "FH069FD_T",
        dryType: "nonHeater",
        cycle: 1000,
    }),
    new Devices({
        id: "84960297-c1fa-16b3-a339-60ab148ff8e5",
        type: "washer",
        name: "Washer 2",
        status: "error",
        courseName: undefined,
        remainTime: undefined,
        model: "FH069FD_T",
        dryType: "nonHeater",
        cycle: 1000,
    })
];

export default DeviceLayoutWasherDummyData;
